"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nameFunction = (name, fn) => {
    const f = fn.bind(null);
    f.displayName = name;
    return f;
};
//# sourceMappingURL=nameFunction.js.map


// WEBPACK FOOTER //
// ./node_modules/react-redux-pure/es6/nameFunction.js